import { PreviousDialogDialogParticipant, } from '../../../proto/ai/inworld/engine/world-engine.pb';
export var DialogParticipant;
(function (DialogParticipant) {
    DialogParticipant["UNKNOWN"] = "UNKNOWN";
    DialogParticipant["PLAYER"] = "PLAYER";
    DialogParticipant["CHARACTER"] = "CHARACTER";
})(DialogParticipant || (DialogParticipant = {}));
var DialogTalker = /** @class */ (function () {
    function DialogTalker() {
    }
    DialogTalker.toProto = function (talker) {
        switch (talker) {
            case DialogParticipant.PLAYER:
                return PreviousDialogDialogParticipant.PLAYER;
            case DialogParticipant.CHARACTER:
                return PreviousDialogDialogParticipant.CHARACTER;
            default:
                return PreviousDialogDialogParticipant.UNKNOWN;
        }
    };
    DialogTalker.fromProto = function (talker) {
        switch (talker) {
            case PreviousDialogDialogParticipant.PLAYER:
                return DialogParticipant.PLAYER;
            case PreviousDialogDialogParticipant.CHARACTER:
                return DialogParticipant.CHARACTER;
            default:
                return DialogParticipant.UNKNOWN;
        }
    };
    return DialogTalker;
}());
export { DialogTalker };
var PreviousDialog = /** @class */ (function () {
    function PreviousDialog(phrases) {
        this.phrases = phrases;
    }
    PreviousDialog.prototype.toProto = function () {
        var phrases = this.phrases.map(function (item) { return ({
            talker: DialogTalker.toProto(item.talker),
            phrase: item.phrase,
        }); });
        return { phrases: phrases };
    };
    PreviousDialog.fromProto = function (dialog) {
        return new PreviousDialog(dialog.phrases.map(function (item) { return ({
            talker: DialogTalker.fromProto(item.talker),
            phrase: item.phrase,
        }); }));
    };
    return PreviousDialog;
}());
export { PreviousDialog };
